<template>
  <div class="history-item" @click="handle2Active">
    <img :src="$isCdn(item.pic)" alt="" />
    <div class="info">
      <div class="title van-multi-ellipsis--l2">
        {{ item.name }}
      </div>
      <div class="date">{{ item.time | formatDate('MM-dd') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  methods: {
    handle2Active() {
      if (this.item.type === '1') {
        this.$router.push(`/resourcePlay/${this.item.id}`)
      } else {
        this.$router.push(`/play/${this.item.id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.history-item {
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.04);
  padding: 16px 14px;
  display: flex;
  border-radius: 12px;
  img {
    width: 132px;
    height: 74px;
    border-radius: 8px;
    margin-right: 16px;
  }
  .info {
    position: relative;
    flex: 1;
    .title {
      word-break: break-all;
      color: #303133;
      font-size: 14px;
      font-weight: 700;
    }
    .date {
      color: #909399;
      font-size: 12px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}
</style>
